import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import _objectDestructuringEmpty from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { fetchSingleOrg } from "@/api/orgs";
import { fetchSingleUser } from "@/api/users";
import i18n from "../../lang";
import ghdJSON from "@/lang/ghd.json";
import translationsJSON from '@/lang/global.json';
var currentOrg = {
  state: {
    org: '',
    name: '',
    logo: ''
  },
  mutations: {
    SET_CURRENT_ORG_ID: function SET_CURRENT_ORG_ID(state, orgID) {
      state.org = orgID;
    },
    SET_CURRENT_ORG_NAME: function SET_CURRENT_ORG_NAME(state, orgName) {
      state.name = orgName;
    },
    SET_CURRENT_ORG_LOGO: function SET_CURRENT_ORG_LOGO(state, orgLogo) {
      state.logo = orgLogo;
    }
  },
  actions: {
    updateCurrentOrgId: function updateCurrentOrgId(_ref, orgID) {
      var dispatch = _ref.dispatch,
          commit = _ref.commit,
          rootState = _ref.rootState;
      commit("SET_CURRENT_ORG_ID", orgID);
      return new Promise(function (resolve, reject) {
        fetchSingleOrg(orgID).then(function (response) {
          var org = response.data;
          commit("SET_CURRENT_ORG_NAME", org.name);

          if (org.logo) {
            commit("SET_CURRENT_ORG_LOGO", org.logo);
          }

          dispatch('updatePhrases', orgID);
          fetchSingleUser(rootState.user._id).then( /*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
              var data;
              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      data = response.data;
                      data.organisation.name = org.name;
                      data.organisation._id = org._id;
                      data.org = org._id; //console.log(data, 'user data, update current org id')

                      _context.next = 6;
                      return dispatch("GenerateRoutes", data, {
                        root: true
                      });

                    case 6:
                      // 动态修改权限后 重绘侧边菜单
                      resolve();

                    case 7:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            return function (_x) {
              return _ref2.apply(this, arguments);
            };
          }());
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    updatePhrases: function updatePhrases(_ref3, org) {
      _objectDestructuringEmpty(_ref3);

      if (org === '5f0d20391ad7a10011168387') {
        i18n.mergeLocaleMessage('en', ghdJSON.en);
      } else {
        i18n.mergeLocaleMessage('en', translationsJSON.en);
      }
    }
  }
};
export default currentOrg;